import PauseCover from './PauseCover';

export default PauseCover;